import { Component, h, Host } from '@stencil/core';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import { v4 as uuidv4 } from 'uuid';

@Component({
  tag: 'lilu-brand-slider',
  styleUrl: 'lilu-brand-slider.scss',
  shadow: false,
})
export class LiluBrandSlider {

  swiperId = uuidv4();

  swiperSelector = `swiper-id-${this.swiperId}`;
  swiperPagination = `swiper-pagination-${this.swiperId}`;
  swiperNextEl = `swiper-button-next-${this.swiperId}`;
  swiperPrevEl = `swiper-button-prev-${this.swiperId}`;

  componentDidLoad() {
    new Swiper(`#${this.swiperSelector}`, {
      modules: [
        Navigation,
        Pagination,
      ],
      speed: 400,
      loop: true,
      slidesPerView: 1.8,
      centeredSlides: true,
      spaceBetween: 20,
      pagination: {
        el: `#${this.swiperPagination}`,
        type: "fraction"
      },
      navigation: {
        nextEl: `#${this.swiperNextEl}`,
        prevEl: `#${this.swiperPrevEl}`,
      },
      threshold: 5
    });
  }

render() {
  return (
    <Host>
      <div class="swiper-brand">
        <div class="swiper-brand-link">
          <slot name='link'></slot>
        </div>
        <lilu-hr></lilu-hr>
        <div class="swiper" id={this.swiperSelector}>
          <div class="swiper-wrapper">
            <slot></slot>
          </div>
        </div>
          <div class="swiper-navigation">
            <div class="swiper-brand-pagination swiper-pagination" id={this.swiperPagination}></div>
            <div class="swiper-button-next" id={this.swiperNextEl}></div>
            <div class="swiper-button-prev" id={this.swiperPrevEl}></div>
          </div>
      </div>
    </Host>
  );
}
}
